export default __webpack_public_path__ + "static/media/ashridgeHQ.0c911ad3.png";